import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  TTopbar,
  TLoginDetails,
  UserStatusContainer,
  UserStatusIcon,
  UserStatusText,
  UserMenuButton,
  NotesIconWrap,
  NotesBadge,
  NotesBadgeLoading,
  NotesBadgeError,
  WhatsNewDot,
} from "./styles";
import { FaUser, FaRegStickyNote, FaGift } from "react-icons/fa";
import Breadcrumbs from "./Breadcrumbs";
import UserPreferencesDialog from "./UserPreferencesDialog";
import WhatsNewDialog from "./WhatsNewDialog";
import {
  getReleases,
  getUnreadReleases,
  markReleasesSeen,
} from "../../helpers/whatsNew";


const Topbar = (props: any) => {
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [preferencesVisible, setPreferencesVisible] = useState<boolean>(false);

  const [whatsNewVisible, setWhatsNewVisible] = useState<boolean>(false);
  const [whatsNewUnread, setWhatsNewUnread] = useState<boolean>(false);
  // Only the unread notes on the automatic showing - a user who has read up to
  // the last release wants to see what has changed since, not the whole
  // history. Opening it deliberately shows everything.
  const [whatsNewReleases, setWhatsNewReleases] = useState(getReleases);
  const [whatsNewAutomatic, setWhatsNewAutomatic] = useState<boolean>(false);

  const showBadge = false; //!loading && !error && count > 0;

  // The topbar mounts once the user is in, so this is the first moment after
  // signing in at which there is somewhere to show the notes.
  useEffect(() => {
    const unread = getUnreadReleases();

    if (unread.length === 0) {
      return;
    }

    setWhatsNewReleases(unread);
    setWhatsNewUnread(true);
    setWhatsNewAutomatic(true);
    setWhatsNewVisible(true);
  }, []);

  const openWhatsNew = () => {
    setWhatsNewReleases(getReleases());
    setWhatsNewAutomatic(false);
    setWhatsNewVisible(true);
  };

  const closeWhatsNew = () => {
    // Closing counts as read however the dialog was opened.
    markReleasesSeen();
    setWhatsNewUnread(false);
    setWhatsNewVisible(false);
  };

  return (
    <TTopbar>
      <Breadcrumbs />

      <TLoginDetails>
        <UserStatusContainer>
          <UserStatusIcon>&nbsp;</UserStatusIcon>
          <UserStatusText>Available</UserStatusText>
        </UserStatusContainer>

        <NotesIconWrap
          type="button"
          title="What's New"
          aria-label="What's New"
          onClick={openWhatsNew}
        >
          <FaGift />
          {whatsNewUnread && <WhatsNewDot />}
        </NotesIconWrap>

        <UserMenuButton
          type="button"
          title="Preferences"
          onClick={() => setPreferencesVisible(true)}
        >
          <FaUser style={{ marginRight: "10px" }} />
          {props.onUserName}
        </UserMenuButton>
      </TLoginDetails>

      {preferencesVisible && (
        <UserPreferencesDialog onClose={() => setPreferencesVisible(false)} />
      )}

      {whatsNewVisible && (
        <WhatsNewDialog
          releases={whatsNewReleases}
          openedAutomatically={whatsNewAutomatic}
          onClose={closeWhatsNew}
        />
      )}
    </TTopbar>
  );
};

export default Topbar;
